export const getProjectsResourcesEmployers = (
  currentUserResources,
  projectId
) => {
  return currentUserResources
    .filter((resource) => resource.project === projectId)
    .map((resource) => resource.employer);
};
